import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { FragmentRemoteComponent } from '@constructor/federation/react'
// @ts-expect-error
import knowledgeCenterRemote from 'virtual:federation/remotes/knowledge-center'
import { useFetchObjectiveKnowledgeModelQuery } from '@/features/km/objectiveKnowledgeModelsApi'
import { useKnowledgeModelSettings } from '@/features/km/useKnowledgeModelSettings'
import { useAppSelector } from '@/store/hooks'

export const KnowledgeModelWidget = () => {
  const settings = useKnowledgeModelSettings()

  const location = useLocation()
  const params = useParams()
  const aggregate = useAppSelector((store) => store.aggregate.current)
  const { id: _aggregateId } = aggregate || {}
  const aggregateIdParam = params?.aggregateIdParam
  const aggregateId = _aggregateId || aggregateIdParam
  const isCourseDetail = location.pathname.includes('/courses') && aggregateId
  const [knowledgeModelId, setKnowledgeModelId] = useState<string | undefined>()

  const {
    data: responseKM,
    isLoading: loadingKM,
    error: errorKM,
  } = useFetchObjectiveKnowledgeModelQuery(aggregateId!, {
    skip: !isCourseDetail || !settings?.enabled,
    refetchOnMountOrArgChange: true,
  })

  useEffect(() => {
    const isProctoringWrapped = window.location.href.includes('inProctoringIframe')

    if (isProctoringWrapped) {
      return
    }

    const initializeWidget = () => {
      if (loadingKM || !settings?.enabled) {
        return
      }

      const getId = () => {
        if (isCourseDetail) {
          if (errorKM) {
            return settings?.defaultKnowledgeModelId?.trim?.()
          }

          return responseKM?.knowledgeModelId || settings?.defaultKnowledgeModelId?.trim?.()
        }

        return settings.defaultKnowledgeModelId?.trim?.()
      }

      const _knowledgeModelId = getId()
      setKnowledgeModelId(_knowledgeModelId)
    }

    initializeWidget()
  }, [settings, isCourseDetail, responseKM?.knowledgeModelId, loadingKM, errorKM])

  if (!knowledgeModelId) {
    return null
  }

  return (
    <FragmentRemoteComponent
      remote={knowledgeCenterRemote}
      properties={{
        config: {
          knowledgeModelId,
        },
        onInit: () => {
          // Widget except it to be a function
        },
      }}
      entryName="chatWidgetInternal"
    />
  )
}
